import { W as WuiDivider$1, d as defineCustomElement$1 } from './p-C9_XXP_a.js';

const WuiDivider = WuiDivider$1;
const defineCustomElement = defineCustomElement$1;

export { WuiDivider, defineCustomElement };
